import Button from '@/components/base/button.component';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ActionButtonsProps {
  onChangePassword: () => void;
  onAdjustPricelist: () => void;
}

export function ActionButtons({
  onChangePassword,
  onAdjustPricelist,
}: ActionButtonsProps) {
  const { t } = useTranslation('customer');

  return (
    <Stack sx={{ mb: 2 }}>
      <Button variant={'outlined'} onClick={onChangePassword} sx={{ mt: 2 }}>
        {t('account.myData.actions.changePassword')}
      </Button>
      {/* <Button
        variant={'outlined'}
        onClick={onAdjustPricelist}
        sx={{ mt: 2 }}
      >
        {t('account.myData.actions.adjustPricelist')}
      </Button> */}
    </Stack>
  );
}
